/*  UI  */
import { Box, Button, Flex } from '@auviknetworks/iceberg-ui';

/* Shared */
import { Route } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

import { usePanelContext } from './PanelContext';

export const PanelFooter = () => {
    const { t } = useTranslation();
    const { clientId, partnerId } = useParams();
    const {
        schema: { id, footer }
    } = usePanelContext();

    const buildBaseRoute = Route.buildBaseRoute({
        clientId,
        partnerId
    });

    return (
        <Flex
            data-testid="dashboardPanelFooter"
            sx={{
                flexWrap: 'wrap',
                gap: '16px',
                minHeight: 0,
                padding: '24px 24px 0'
            }}
        >
            {(footer?.actions || []).map(({ href, label, format }) => {
                const isPartialPath = href.startsWith('/');
                return (
                    <Link
                        data-trackid={`panelActionLink_${id}`}
                        to={isPartialPath ? `${buildBaseRoute}${href}` : href}
                        key={label}
                        {...(isPartialPath ? {} : { relative: 'path' })}
                    >
                        <Button
                            data-trackid={`panelActionBtn_${id}`}
                            variant={format?.variant}
                            size={format?.size}
                        >
                            <Box>{t(label)}</Box>
                        </Button>
                    </Link>
                );
            })}
        </Flex>
    );
};
